const TOKEN_TYPES = {
  EMAIL_VERIFICATION: "emailVerification",
  PASSWORD_RESET: "passwordReset",
  ORGANIZATION_MEMBER_VERIFICATION: "organizationMemberVerification",
};

module.exports = { TOKEN_TYPES };
